import { render } from "./persistentvolumeclaim.vue?vue&type=template&id=bcf08080"
import script from "./persistentvolumeclaim.vue?vue&type=script&lang=js"
export * from "./persistentvolumeclaim.vue?vue&type=script&lang=js"

import "./persistentvolumeclaim.vue?vue&type=style&index=0&id=bcf08080&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__